import {Component, forwardRef, HostListener, inject, input, output} from '@angular/core';
import {INotificationItem, NOTIFICATION_ITEM_TOKEN} from '../notification-item.base';
import {NOTIFICATION_CLICK_HANDLER_TOKEN} from '../notification-click.handler';

@Component({
  selector: 'app-notification-item',
  imports: [],
  templateUrl: './notification-item.component.html',
  styleUrl: './notification-item.component.scss',
  providers: [
    {
      provide: NOTIFICATION_ITEM_TOKEN,
      useExisting: forwardRef(() => NotificationItemComponent),
      multi: true
    }
  ],
  host: {
    '[attr.notification-item-test-id]': 'id()',
  }
})
export class NotificationItemComponent implements INotificationItem {
  id = input('');
  title = input('');
  description = input('');
  timestamp = input('');
  itemClicked = output<string>();

  private readonly clickHandler = inject(NOTIFICATION_CLICK_HANDLER_TOKEN);

  @HostListener('click')
  onClick(): void {
    // This method can be overridden by derived classes
    this.handleClick();
  }

  // Protected method that can be overridden by derived classes
  handleClick(): void {
    // Base implementation
    this.clickHandler.handleClick(this.id());
  }
}
